import Button from 'components/Button';
import LoginLink from 'components/LoginLink';
import useScreenSize from 'hooks/useScreenSize';
import { useUser } from 'stores/userStore';
import { SelectedPhotoType, usePhotoGalleryContainer } from '..';
import PhotoGalleryResolutionSelect from './PhotoGalleryResolutionSelect';
import styles from './styles/PhotoGalleryModalDetails.module.scss';
import Link from 'components/Link';

export default function PhotoGalleryModalDetails() {
  const [{ photoGallery, currentIndex, selectedPhotos, currentSelection, photoSlides }, { setSelectedPhotos, setShowCart, isPhoto, isAd }] =
    usePhotoGalleryContainer();
  const { isSmallScreen } = useScreenSize();
  const user = useUser();

  const slide = photoSlides[currentIndex];
  const slideIsPhoto = isPhoto(slide);
  const highResolutionDisplayPrice =
    slideIsPhoto && slide.highResolutionDisplayPrice ? slide.highResolutionDisplayPrice : photoGallery.highResolutionDisplayPrice;
  const lowResolutionDisplayPrice =
    slideIsPhoto && slide.lowResolutionDisplayPrice ? slide.lowResolutionDisplayPrice : photoGallery.lowResolutionDisplayPrice;
  const highResolutionPriceInCents =
    slideIsPhoto && slide.highResolutionPriceInCents ? slide.highResolutionPriceInCents : photoGallery.highResolutionPriceInCents;
  const lowResolutionPriceInCents =
    slideIsPhoto && slide.lowResolutionPriceInCents ? slide.lowResolutionPriceInCents : photoGallery.lowResolutionPriceInCents;

  const alreadySelected = selectedPhotos.some(photo => photo.index === currentIndex && photo.resolution === currentSelection.resolution);

  function handleButtonClick() {
    if (!photoGallery.monetizable || isAd(slide)) return;
    let updatedSelection: SelectedPhotoType[];
    const { resolution, isHighResolution } = currentSelection;
    const displayPrice = slideIsPhoto && isHighResolution ? highResolutionDisplayPrice : lowResolutionDisplayPrice;
    const price = isHighResolution ? highResolutionPriceInCents : lowResolutionPriceInCents;
    if (alreadySelected) {
      updatedSelection = selectedPhotos.filter(photo => !(photo.index === currentIndex && photo.resolution === resolution));
    } else {
      updatedSelection = [
        ...selectedPhotos,
        {
          index: currentIndex,
          resolution,
          displayPrice,
          price,
          isHighResolution
        }
      ];
    }

    setSelectedPhotos(updatedSelection);
  }

  return (
    <div className={styles.ModalDetails}>
      {photoGallery.monetizable ? (
        <>
          <Button
            label={alreadySelected ? 'Remove From Cart' : 'Add to Cart'}
            type="v2"
            className={styles.AddToCartButton}
            onClick={handleButtonClick}
            disabled={!photoGallery.monetizable || isAd(slide)}
          />
          <PhotoGalleryResolutionSelect />
          {!user.isLoggedIn && (
            <div className={styles.DiscountText}>
              Registered SBLive users get 10% off photo purchases and access to special members-only benefits.
              <LoginLink className={styles.SignUpText} style={{ display: 'inline' }}>
                &nbsp;Sign up for a free account&nbsp;
              </LoginLink>
              to get started.
            </div>
          )}
          <div className={styles.PhotoPrices}>
            Prices are set by photographers, who own and retain copyright to all photos. The SBLive watermark is not included in purchased
            photos.
          </div>
        </>
      ) : (
        <div className={styles.NotForSale}>
          This photo is not for sale at this time. Contact us at{' '}
          <Link href="mailto:support@scorebooklive.com">support@scorebooklive.com</Link> to learn more about this photo.
        </div>
      )}
    </div>
  );
}
